import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'

import createReactClass from 'create-react-class'

export default createReactClass({
  displayName: 'Submit',

  propTypes: {
    className: PropTypes.string,
    disableIfInvalid: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    value: PropTypes.string,
    children: PropTypes.node,
  },

  contextTypes: {
    form: PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {
      disabled: false,
      disableIfInvalid: false,
      onClick: _.identity,
    }
  },

  getInitialState() {
    return {
      isValid: false,
    }
  },

  onFormStateUpdate(data) {
    const isValid = _.isEmpty(_.get(data, 'errors'))

    this.setState({
      isValid,
    })
  },

  UNSAFE_componentWillMount() {
    /* istanbul ignore next */
    if (!this.context.form) {
      throw Error(
        `react-form.tools: Submit must be used only inside Form component`
      )
    }
  },

  componentDidMount() {
    this.context.form.subscribe(this.onFormStateUpdate)
  },

  componentWillUnmount() {
    this.context.form.unsubscribe(this.onFormStateUpdate)
  },

  handleClick(event) {
    if (!this.context.form.isHtmlForm()) {
      event.preventDefault()
      event.stopPropagation()
      this.context.form.submit()
    }

    this.props.onClick(event)
  },

  render() {
    const {
      className,
      disabled,
      disableIfInvalid,
      value,
      children,
      restProps,
    } = this.props
    const { isValid } = this.state

    return (
      <input
        {...restProps}
        type="submit"
        onClick={this.handleClick}
        className={classNames(
          'cursor-pointer rounded-md bg-success py-4 px-5 uppercase tracking-widest text-white transition-colors hover:bg-success-dark disabled:cursor-default disabled:bg-black/10',
          className
        )}
        disabled={(disableIfInvalid && !isValid) || disabled}
        value={value || children}
      />
    )
  },
})
